import { render, staticRenderFns } from "./_email.vue?vue&type=template&id=137f34d8&"
import script from "./_email.vue?vue&type=script&lang=ts&"
export * from "./_email.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports